import * as yup from 'yup';
import {
	Row,
	RenderConfig,
	TextInput,
	AssetUploadInputOnS3,
	ASSET_TYPE,
	SelectInput,
	BOOLEAN_OPTIONS,
	EMPTY_ARRAY,
	Column
} from 'commons-ui';

export const FORM_FIELD_KEYS = {
	TITLE_EN: 'titleEn',
	TITLE_HI: 'titleHi',
	TITLE_MR: 'titleMr',
	SUBTITLE_EN: 'subTitleEn',
	SUBTITLE_HI: 'subTitleHi',
	SUBTITLE_MR: 'subTitleMr',
	TITLE_ACTIVE: 'titleActive',
	SUBTITLE_ACTIVE: 'subTitleActive',
	LIKES: 'likes',
	SHARES: 'shares',
	CREATED_AT: 'createdAt',
	UPDATED_AT: 'updatedAt',
	IMAGE_URL: 'imageUrl',
	LIVE_TILL: 'liveTill'
};

export const validationSchema = yup.object().shape({
	titleEn: yup.string().required('English Title is a required field'),
	titleHi: yup.string().required('Hindi Title is a required field'),
	titleMr: yup.string().required('Marathi Title is a required field'),
	subTitleEn: yup.string().required('English SubTitle is a required field'),
	subTitleHi: yup.string().required('Hindi SubTitle is a required field'),
	subTitleMr: yup.string().required('Marathi SubTitle is a required field'),
	liveTill: yup
		.number()
		.transform((value, originalValue) => {
			if (originalValue === '' || originalValue === null) {
				return undefined;
			}
			return originalValue;
		})
		.test({
			message: 'Live Till date should be a valid date',
			test: (value: any) => value !== '' || value !== null || !Number.isNaN(new Date(value).getTime())
		})
		.required('Live Till date is a required field'),
	imageUrl: yup.string().required('Memes can not be created without the image is a required field')
});

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.TITLE_EN]: new RenderConfig()
		.setName('titleEn')
		.setLabel('Title En')
		.setRenderer(TextInput)
		.setRenderProps({ isEditable: { create: true, edit: true }, required: true }),
	[FORM_FIELD_KEYS.TITLE_HI]: new RenderConfig()
		.setName('titleHi')
		.setLabel('Title Hi')
		.setRenderer(TextInput)
		.setRenderProps({ isEditable: { create: true, edit: true }, required: true }),
	[FORM_FIELD_KEYS.TITLE_MR]: new RenderConfig()
		.setName('titleMr')
		.setLabel('Title Mr')
		.setRenderer(TextInput)
		.setRenderProps({ isEditable: { create: true, edit: true }, required: true }),
	[FORM_FIELD_KEYS.SUBTITLE_EN]: new RenderConfig()
		.setName('subTitleEn')
		.setLabel('SubTitle En')
		.setRenderer(TextInput)
		.setRenderProps({ isEditable: { create: true, edit: true }, required: true }),
	[FORM_FIELD_KEYS.SUBTITLE_HI]: new RenderConfig()
		.setName('subTitleHi')
		.setLabel('SubTitle Hi')
		.setRenderer(TextInput)
		.setRenderProps({ isEditable: { create: true, edit: true }, required: true }),
	[FORM_FIELD_KEYS.SUBTITLE_MR]: new RenderConfig()
		.setName('subTitleMr')
		.setLabel('SubTitle Mr')
		.setRenderer(TextInput)
		.setRenderProps({ isEditable: { create: true, edit: true }, required: true }),
	[FORM_FIELD_KEYS.LIKES]: new RenderConfig()
		.setName('likes')
		.setLabel('Likes')
		.setRenderer(TextInput)
		.setRenderProps({ isEditable: { create: false, edit: false }, required: false }),
	[FORM_FIELD_KEYS.SHARES]: new RenderConfig()
		.setName('shares')
		.setLabel('Shares')
		.setRenderer(TextInput)
		.setRenderProps({ isEditable: { create: false, edit: false }, required: false }),
	[FORM_FIELD_KEYS.CREATED_AT]: new RenderConfig()
		.setName('createdAt')
		.setLabel('Created At')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: false, edit: false },
			inputType: 'datetime-local',
			format: 'yyyy-dd-mm HH:MM:ss',
			required: false
		}),
	[FORM_FIELD_KEYS.UPDATED_AT]: new RenderConfig()
		.setName('updatedAt')
		.setLabel('Updated At')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: false, edit: false },
			inputType: 'datetime-local',
			format: 'yyyy-dd-mm HH:MM:ss',
			required: false
		}),
	[FORM_FIELD_KEYS.TITLE_ACTIVE]: new RenderConfig()
		.setName('titleActive')
		.setLabel('Title Active')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			options: BOOLEAN_OPTIONS,
			required: true
		}),
	[FORM_FIELD_KEYS.SUBTITLE_ACTIVE]: new RenderConfig()
		.setName('subTitleActive')
		.setLabel('SubTitle Active')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			options: BOOLEAN_OPTIONS,
			required: true
		}),
	[FORM_FIELD_KEYS.IMAGE_URL]: new RenderConfig()
		.setName('imageUrl')
		.setLabel('Image')
		.setRenderer(AssetUploadInputOnS3)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			required: true,
			assetType: ASSET_TYPE.MEME,
			usePresignedUrl: true
		}),
	[FORM_FIELD_KEYS.LIVE_TILL]: new RenderConfig()
		.setName('liveTill')
		.setLabel('Live Till')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			inputType: 'datetime-local',
			format: 'yyyy-dd-mm HH:MM:ss',
			required: true
		})
};

export const FORM_LAYOUT_CONFIG = [
	new Row(FORM_FIELD_KEYS.TITLE_EN),
	new Row(FORM_FIELD_KEYS.TITLE_HI),
	new Row(FORM_FIELD_KEYS.TITLE_MR),
	new Row(FORM_FIELD_KEYS.SUBTITLE_EN),
	new Row(FORM_FIELD_KEYS.SUBTITLE_HI),
	new Row(FORM_FIELD_KEYS.SUBTITLE_MR),
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.LIKES)]), new Column([new Row(FORM_FIELD_KEYS.SHARES)])]),
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.TITLE_ACTIVE)]),
		new Column([new Row(FORM_FIELD_KEYS.SUBTITLE_ACTIVE)])
	]),
	new Row(FORM_FIELD_KEYS.IMAGE_URL),
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.CREATED_AT)]),
		new Column([new Row(FORM_FIELD_KEYS.UPDATED_AT)])
	]),
	new Row(FORM_FIELD_KEYS.LIVE_TILL)
];
